"use client";

import React from "react";
import { PageError as Error } from "@oreme/ui";
import { useTranslations } from "next-intl";

function SharedPageError() {
  const t = useTranslations("global.Error");
  return <Error title={t("title")} message={t("message")} />;
}

export { SharedPageError };
